<template>
  <Insights
    :module="'social_media'"
    :roleIdProp="roleIdProp"
    :citiesString="citiesString"
    :states="states"
    :moduleId="roleIdProp"
    insights-api-url="/api/social-media/insights"
    prompts-api-url="/api/user-prompts"
    :dataSourceOptions="dataSourceOptions"
  />
</template>

<script>
import Insights from '@/Shared/Insights/Insights.vue'

export default {
  name: 'SocialMediaInsights',
  components: {
    Insights
  },
  props: {
    roleIdProp: {
      type: Number,
      required: true
    },
    citiesString: {
      type: String,
      default: ''
    },
    states: {
      type: Array,
      default: () => []
    },
    termsSelect: {
      type: Array,
      default: () => []
    },
    termId: {
      type: [String, Number],
      default: null
    },
    socialMediaData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      dataSourceOptions: [
        { id: 'trending_posts', label: 'Postagens em alta' },
        { id: 'demographic_map', label: 'Mapa de distribuição demográfica' },
        { id: 'tourist_spots', label: 'Pontos turísticos mais citados' },
        { id: 'trending_topics', label: 'Assuntos do momento' },
        { id: 'relevant_events', label: 'Eventos relevantes' },
        { id: 'trending_keywords', label: 'Palavras-chave em alta' },
        { id: 'top_influencers', label: 'Top Influenciadores' },
        { id: 'word_cloud', label: 'Nuvem de palavras' }
      ]
    }
  },
  methods: {
    // Métodos específicos para social media, se necessário
  }
}
</script>

<style scoped>
/* Estilos específicos para os Insights de social media, se necessário */
</style>